var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uni-tooltip"},[_vm._t("default"),(_vm.content || _vm.$slots.content)?_c('div',{staticClass:"uni-tooltip-popup"},[_vm._t("content",function(){return [_vm._v(" "+_vm._s(_vm.content)+" ")]})],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }